<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a>
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
    </ul>
  </div>
  <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', 'neu']">
    <i class="fa fa-plus"></i>
    Lieferschein erstellen
  </a>
</div>
<div class="page-content page-frame overflow-y-auto">
  <form (submit)="search()" [formGroup]="form" class="page-sheet max-w-6xl mx-auto shadow">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Lieferscheinnummer</label>
        <input class="bm-input w-full" type="text" formControlName="number" />

        <label class="bm-fieldset-label">Status</label>
        <ng-select
          class="w-full"
          [items]="statusList"
          bindLabel="description"
          bindValue="id"
          formControlName="status_id"
          placeholder="Status auswählen"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.description }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (!search || item.description.toLowerCase().includes(searchTerm.toLowerCase())) {
              {{ item.description }}
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Absenderort</label>
        <input class="bm-input w-full" type="text" formControlName="sender_city" />

        <label class="bm-fieldset-label">Lager Absender</label>
        <ng-select
          class="w-full"
          [items]="warehouses"
          bindLabel="label"
          bindValue="id"
          formControlName="sender_warehouse_id"
          placeholder="Lager Absender"
          [clearable]="false"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.label }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div>
                {{ item.label }}
              </div>
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Empfängerort</label>
        <input class="bm-input w-full" type="text" formControlName="recipient_city" />

        <label class="bm-fieldset-label">Lager Empfänger</label>
        <ng-select
          class="w-full"
          [items]="warehouses"
          bindLabel="label"
          bindValue="id"
          formControlName="recipient_warehouse_id"
          placeholder="Lager Empfänger"
          [clearable]="false"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.label }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
              <div>
                {{ item.label }}
              </div>
            }
          </ng-template>
        </ng-select>

        <div class="bm-fieldset">
          <label class="bm-fieldset-label"> Erstellungsdatum </label>
          <div class="bm-join">
            <div class="bm-join-item bm-input w-full">
              <input
                class="w-full bm-join-item"
                [formControl]="form.controls.create_date_from"
                [matDatepicker]="pickerFrom"
                placeholder="von"
                (click)="pickerFrom.open()"
                (focus)="pickerFrom.open()"
              />
              <mat-datepicker #pickerFrom />

              <input
                class="w-full bm-join-item"
                [formControl]="form.controls.create_date_to"
                [matDatepicker]="pickerTo"
                placeholder="bis"
                (click)="pickerTo.open()"
                (focus)="pickerTo.open()"
              />
              <mat-datepicker #pickerTo />
              @if (form.controls.create_date_from.value || form.controls.create_date_to.value) {
                <span (click)="clearDate()" class="cursor-pointer">
                  <fa-icon [icon]="['far', 'times']" />
                </span>
              }
            </div>
          </div>
          <div class="flex flex-row gap-1">
            <button type="button" tabindex="-1" class="bm-btn bm-btn-xs bm-btn-primary" (click)="setRange('today')">
              heute
            </button>
            <button type="button" tabindex="-1" class="bm-btn bm-btn-xs bm-btn-primary" (click)="setRange('thisweek')">
              diese Woche
            </button>
            <button type="button" tabindex="-1" class="bm-btn bm-btn-xs bm-btn-primary" (click)="setRange('nextweek')">
              nächste Woche
            </button>
          </div>
        </div>
      </fieldset>
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Produktkategorie</label>
        <ng-select
          class="w-full"
          [items]="productCategories"
          bindLabel="name"
          bindValue="id"
          formControlName="product_category"
          placeholder="Projekt auswählen"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
            @if (!search || item.toLowerCase().includes(search.toLowerCase())) {
              {{ item }}
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">Produkt</label>
        <ng-select
          class="w-full"
          [items]="products"
          bindLabel="description"
          bindValue="id"
          formControlName="product_id"
          placeholder="Produkt"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.description }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
            @if (!search || item.description.toLowerCase().includes(search.toLowerCase())) {
              {{ item.description }}
            }
          </ng-template>
        </ng-select>

        <label class="bm-fieldset-label">RMA-Nr</label>
        <input class="bm-input w-full" type="text" formControlName="rma" />

        <label class="bm-fieldset-label">Seriennummer</label>
        <input class="bm-input w-full" type="text" formControlName="serial_number" />
      </fieldset>
    </div>
    <div class="flex flex-row justify-end gap-2">
      <button class="bm-btn bm-btn-primary">Abfrage starten</button>
    </div>
  </form>
</div>
